
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Options } from '@/entities/conversation'
import { defaultCsatOptions } from '@/transforms/conversation'

@Component<ReselectScore>({})
export default class ReselectScore extends Vue {
    @Prop({ type: Number, default: 1 }) public score!: number
    @Prop({ type: String, default: 'nps' }) public questionType!: string
    @Prop({ type: Boolean, default: false }) public interact!: boolean
    @Prop({ type: Array, default: () => defaultCsatOptions() })
    public csatLabels!: Options

    // An issue does exist where switching from not isFiveStar to isFiveStar
    // causes a blank score to display.  But that should be a no-go from a
    // operational standpoint.
    public get selectedScore() {
        return this.score
    }

    public set selectedScore(newScore) {
        this.$emit('updatescore', { score: newScore })
    }

    public get currentScore() {
        return this.formatScore(this.score)
    }

    public get availableOptions() {
        // NPS: 0 - 10
        // FiveStar: 1 - 5
        const options: { label: string; value: string }[] = []
        switch (this.questionType) {
            case 'csat':
                for (const { key, value } of this.csatLabels) {
                    options.push({
                        label: value,
                        value: key,
                    })
                }
                return options
            case 'fivestar':
                for (let value = 1; value < 6; value++) {
                    options.push({
                        label: this.formatScore(value),
                        value: `${value}`,
                    })
                }
                return options
            default:
                for (let value = 0; value < 11; value++) {
                    options.push({
                        label: this.formatScore(value),
                        value: `${value}`,
                    })
                }
                return options
        }
    }

    public formatScore(value) {
        switch (this.questionType) {
            case 'csat': {
                const option = this.csatLabels.find(({ key }) => key == value)
                return option ? option.value : `${value}`
            }
            case 'fivestar': {
                return `${value}☆`
            }
            default: {
                return `${value}`
            }
        }
    }
}
